export default {
  translation: {
    jsonEditor: 'JSON Editor',
    format: 'Format',
    compress: 'Compress',
    copy: 'Copy',
    clear: 'Clear',
    copied: 'Copied!',
    copyFailed: 'Copy failed',
    enterJson: 'Enter JSON here...',
    enterSearchText: 'Enter search text, press Enter...',
    pleaseEnterJson: 'Please enter JSON content',
    invalidJson: 'Invalid JSON format',
    jsonFormatter: 'JSON',
    textProcessor: 'Text',
    sqlFormatter: 'SQL',
    settings: 'Settings',
    language: 'Language',
    pleaseEnterSQL: 'Enter SQL here...',
    invalidSQL: 'Invalid SQL',
    formatFailed: 'Format failed',
    compressFailed: 'Compress failed',
    sqlFormatter: 'SQL',
    enterSQLHere: 'Enter SQL here...',
    pleaseEnterText: 'Please enter text content',
    textSplit: 'Please select split mode and enter delimiter',
    textProcessor: 'Text Processor',
    pleaseEnterAddChar: 'Enter the character to add',
    row_header: 'row header',
    row_tail: 'row tail',
    row_split: 'row split',
    pleaseEnterMultiText: 'Enter multiple text here',
    row_asc: 'Asc',
    row_desc: 'Desc',
    row_add: 'Add',
    row_cut: 'Cut',
    row_lineBreak: 'LineBreak',
    about: 'About',
    aboutDescription: 'This is a React Tools application. Feel free to contact me if you have any questions.',
    myEmail: 'pengchangchengde@gmail.com',
    qrCode: 'QR Code',
    qrCodeGenerator: 'QR Code Generator',
    enterQrContent: 'Enter content to generate QR code',
    size: 'Size',
    foregroundColor: 'Foreground Color',
    backgroundColor: 'Background Color',
    errorCorrectionLevel: 'Error Correction Level',
    low: 'Low',
    medium: 'Medium',
    quartile: 'Quartile',
    high: 'High',
    downloadQrCode: 'Download QR Code'
  }
};